export default "__VITE_ASSET__BON04ArW__"